// TODO: это либо да, либо нет. Разве нет?
export enum ALERT_ACTION_ENUM {
  YES = 2,
  OK = 1,
  NO = 1,
  CANCEL = 0,
}
